import { makeAutoObservable, runInAction } from 'mobx'
import agent from '../api/agent'

export default class VoteStore {
  loading = false

  constructor () {
    makeAutoObservable(this)
  }

  castVote = async (targetType: number, targetId: string, value: number) => {
    this.loading = true
    try {
      await agent.Votes.cast(targetType, targetId, value)
      runInAction(() => (this.loading = false))
      return true
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }

  removeVote = async (targetType: number, targetId: string) => {
    this.loading = true
    try {
      await agent.Votes.remove(targetType, targetId)
      runInAction(() => (this.loading = false))
      return true
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }
}
